"use client";

import { Mail } from "lucide-react";

export interface EmailPreviewProps {
  filename: string;
  citedText: string;
}

export function EmailPreview({ filename, citedText }: EmailPreviewProps) {
  return (
    <div className="p-3 space-y-2">
      <div className="flex items-center gap-2 text-xs text-blue-600 dark:text-blue-400 font-medium">
        <Mail className="h-3.5 w-3.5 flex-shrink-0" />
        <span className="truncate">{filename}</span>
      </div>
      {/* quovy-lint-ignore prefer-notice -- quoted-citation excerpt box, not a status message */}
      <div className="bg-blue-50 dark:bg-blue-950/30 rounded-md p-2 border border-blue-100 dark:border-blue-900">
        <p className="text-sm text-stone-600 dark:text-stone-300 leading-relaxed line-clamp-4">
          {citedText}
        </p>
      </div>
    </div>
  );
}
